import { ConfigProvider, Pagination } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

import { cn } from '@/lib/utils';

const LcPagination = ({
  className,
  showQuickJumper = true,
  defaultCurrent,
  total,
  pageCb,
  pageSize = 10,
  sizeCb,
  size,
  align = 'right',
  showSizeChanger,
  currentPage,
}) => {
  function onChange(pageNumber) {
    pageCb && pageCb(pageNumber);
  }
  function onShowSizeChange(current, pageSize) {
    sizeCb && sizeCb({ current, pageSize });
  }
  function showTotal() {
    return `共 ${total} 项`;
  }
  const ZhLocale = zhCN;
  ZhLocale.lang = {
    ...zhCN.Pagination,
  };
  return (
    <ConfigProvider locale={ZhLocale}>
      <div>
        <Pagination
          locale={ZhLocale}
          className={cn('float-right m-[20px_10px_10px_10px]', className)}
          defaultCurrent={defaultCurrent}
          current={currentPage}
          total={total}
          onChange={onChange}
          onShowSizeChange={onShowSizeChange}
          showTotal={showTotal}
          size={size}
          align={align}
          pageSize={pageSize}
          showQuickJumper={showQuickJumper}
          showSizeChanger={showSizeChanger}
        />
      </div>
    </ConfigProvider>
  );
};

export default LcPagination;
